import { handleRequest } from "../utilities/requestHandler";

export const getTopPurchasedProduct = (req_body) =>
    handleRequest("post","/products/get_top_purchased",req_body);